import React, { memo, useMemo } from "react"
import { Box } from "@chakra-ui/react"

import { useGiftWithPurchase } from "@app/hooks/useGiftWithPurchase"
import { GiftWithPurchaseSwiper } from "@app/components/Cart/GiftWithPurchase/GiftWithPurchaseSwiper"

type Props = {
  isCartPage?: boolean
}

export const GiftWithPurchase: React.FC<Props> = memo(({ isCartPage }) => {
  const { giftWithPurchaseVisible, giftWithPurchaseProducts, isAboveMinimumSpend, gwpSettings } = useGiftWithPurchase(true)

  const isAutoAddProductIncluded = useMemo(() => !!giftWithPurchaseProducts?.find(p => p.autoAdd), [giftWithPurchaseProducts])

  const title = (isAboveMinimumSpend ? gwpSettings?.titleQualified : gwpSettings?.titleUnqualified) || ""

  return !isAutoAddProductIncluded && giftWithPurchaseVisible ? (
    <Box id="cart-gwp" pt={isCartPage ? "4.5" : "2"} pb={isCartPage ? "4.5" : "2"} mb="2" width="full">
      {giftWithPurchaseProducts.length > 0 && (
        <GiftWithPurchaseSwiper isAboveMinimumSpend={isAboveMinimumSpend} products={giftWithPurchaseProducts} title={title} />
      )}
    </Box>
  ) : null
})
